window.CannabisLimits = (function () {
  'use strict';

  const MAX_WEIGHT    = 100;
  const MAX_PRODUCTS  = 5;
  const TYPE_LIMITS   = { Batterie: 1, Vape: 3 };
  const MULTIPLIERS   = { 'Blüte': 5, Extrakt: 30, Vape: 1, Batterie: 1 };
  const PROGRESS_COLOR = '#5b663c';

  function getMultiplier(adminType) {
    return MULTIPLIERS[adminType] || 5;
  }

  function isWeightType(adminType) {
    return adminType !== 'Vape' && adminType !== 'Batterie';
  }

  function unitFor(adminType) {
    if (adminType === 'Extrakt') return 'ml';
    if (adminType === 'Vape' || adminType === 'Batterie') return 'Stück';
    return 'g';
  }

  const _debounceTimers = {};
  function debounce(key, fn, delay) {
    clearTimeout(_debounceTimers[key]);
    _debounceTimers[key] = setTimeout(fn, delay);
  }

  function safeJson(response) {
    if (!response.ok) return Promise.resolve(null);
    return response.json().catch(() => null);
  }

  function getCartWeightFromDOM() {
    let total = 0;
    document.querySelectorAll('[data-item][data-sku-base-amount]').forEach((item) => {
      const adminType = item.getAttribute('data-administration-type') || '';
      if (!isWeightType(adminType)) return;

      const base = parseFloat(item.getAttribute('data-sku-base-amount'));
      const m    = getMultiplier(adminType);
      const input = item.querySelector('[data-quantity-field]');
      if (!input) return;
      let raw = parseInt(input.value, 10);
      if (isNaN(raw) || raw < 1) return;
      const effective = Math.max(1, Math.round(raw / m));

      if (!isNaN(base)) total += base * effective;
    });
    return total;
  }

  function getCartWeightFromAPI() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        let total = 0;
        cart.items.forEach((item) => {
          const adminType = (item.properties && item.properties._administration_type) || '';
          if (!isWeightType(adminType)) return;

          const base = parseFloat((item.properties && item.properties._sku_base_amount) || 0);
          if (!base || isNaN(base)) return;

          const m = getMultiplier(adminType);
          const effective = Math.max(1, Math.round((item.quantity || 1) / m));
          total += base * effective;
        });
        return total;
      });
  }

  function getTypeQuantityFromDOM(adminType) {
    let total = 0;
    document.querySelectorAll('[data-item]').forEach((item) => {
      if ((item.getAttribute('data-administration-type') || '') === adminType) {
        const input = item.querySelector('[data-quantity-field]');
        total += input ? (parseInt(input.value, 10) || 0) : 0;
      }
    });
    return total;
  }

  function getTypeLimit(adminType) {
    return TYPE_LIMITS[adminType] || null;
  }

  function disableButton(btn, reason) {
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.title = reason || '';
    btn.style.setProperty('opacity', '0.5', 'important');
    btn.style.setProperty('cursor', 'not-allowed', 'important');
    btn.style.setProperty('pointer-events', 'none', 'important');
  }

  function enableButton(btn) {
    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
    btn.title = '';
    btn.style.removeProperty('opacity');
    btn.style.removeProperty('cursor');
    btn.style.removeProperty('pointer-events');
  }

  function updateProgressBar() {
    const total = getCartWeightFromDOM();
    const pct   = Math.min((total / MAX_WEIGHT) * 100, 100);
    const over  = total > MAX_WEIGHT;

    const fill    = document.querySelector('[data-progress-fill]');
    const amount  = document.querySelector('[data-progress-amount]');
    const message = document.querySelector('[data-progress-message]');

    if (fill) {
      fill.style.width = pct + '%';
      fill.style.backgroundColor = PROGRESS_COLOR;
    }
    if (amount) {
      amount.textContent = total + ' g/ml';
    }
    if (message) {
      message.textContent = 'Du kannst bis zu ' + Math.max(0, MAX_WEIGHT - total) + ' g/ml hinzufügen';
    }

    document.querySelectorAll('.cart__checkout, button[name="questionnaire"]').forEach((btn) => {
      if (over) {
        btn.disabled = true;
        btn.title = 'Bitte Menge reduzieren — 100 g/ml Limit überschritten';
        btn.style.setProperty('opacity', '0.5', 'important');
        btn.style.setProperty('cursor', 'not-allowed', 'important');
      } else {
        btn.disabled = false;
        btn.title = '';
        btn.style.removeProperty('opacity');
        btn.style.removeProperty('cursor');
      }
    });

    const warning = document.querySelector('[data-limit-warning]');
    if (warning) warning.style.display = over ? 'block' : 'none';
  }

  function showError(message) {
    dismissNotification();
    let el = document.createElement('div');
    el.className = 'cart-limit-error';
    document.body.appendChild(el);
    el.style.cssText =
      'position:fixed;top:20px;right:20px;background:#DB4353;color:#fff;' +
      'padding:15px 20px;border-radius:8px;z-index:9999;' +
      'box-shadow:0 4px 12px rgba(0,0,0,.2);font-size:14px;max-width:320px;' +
      'font-family:var(--BODY-FONT-FAMILY, sans-serif);';
    el.innerHTML =
      '<div style="display:flex;align-items:center;gap:10px">' +
        '<div><strong>Warenkorb-Hinweis</strong><br>' + message + '</div>' +
        '<button onclick="this.closest(\'.cart-limit-error\').remove()" ' +
          'style="background:none;border:none;color:#fff;font-size:18px;cursor:pointer;margin-left:auto;padding:0 0 0 8px">\u00D7</button>' +
      '</div>';
    setTimeout(() => { if (el.parentElement) el.remove(); }, 5000);
  }

  function dismissNotification() {
    document.querySelectorAll('.cart-limit-error').forEach(function(el) { el.remove(); });
  }

  // The cart drawer's static [data-cart-errors] block is shown via JS-driven
  // slideDown and only hidden on specific code paths. When the cart contents
  // change successfully (item removed, quantity changed) we want to clear that
  // block so a previous error doesn't linger across subsequent operations.
  function dismissDrawerError() {
    const holder = document.querySelector('[data-cart-errors]');
    if (!holder) return;
    holder.style.display = 'none';
    holder.style.removeProperty('height');
    holder.style.removeProperty('overflow');
    const msg = holder.querySelector('[data-error-message]');
    if (msg) msg.innerText = '';
  }

  // QA reported the cart drawer dropdown showing mixed "5g / 10 grams / 15g / 20 grams".
  // Our Liquid generates "Ng" uniformly, so the inconsistency comes from upstream data
  // (variant titles set in Shopify admin, or theme-editor drift). Normalize defensively so
  // the rendered options always match: "{n}g" / "{n}ml" / "{n} Stück".
  function normalizeQtyOptions() {
    const selects = document.querySelectorAll('[data-cart-qty-select], [data-pdp-qty-select]');
    selects.forEach((select) => {
      const holder = select.closest('[data-administration-type]');
      const adminType = holder ? holder.getAttribute('data-administration-type') || '' : '';
      const unit = unitFor(adminType);
      const isWeight = isWeightType(adminType);
      Array.from(select.options).forEach((opt) => {
        const text = (opt.textContent || '').trim();
        const numMatch = text.match(/^(\d+(?:[.,]\d+)?)/);
        if (!numMatch) return;
        const n = numMatch[1].replace(',', '.');
        const normalized = isWeight ? n + unit : n + ' ' + unit;
        if (opt.textContent !== normalized) opt.textContent = normalized;
      });
    });
  }

  // Reflect the cart-side caps (5 unique products, 100 g/ml, 3 Vape, 1 Batterie) on every
  // grid-card ATC button so users don't see a red "Hinzufügen" button that quietly fails
  // after click. PDPs handle their own state via recompute() in section-nuggmd-product-info.
  function syncCardButtons(cart) {
    if (!cart) return;
    const uniqueProducts = new Set();
    const cartVariantIds = new Set();
    let cartWeight = 0, cartVape = 0, cartBattery = 0;
    cart.items.forEach((item) => {
      uniqueProducts.add(item.product_id);
      cartVariantIds.add(item.variant_id);
      const t = (item.properties && item.properties._administration_type) || '';
      if (t === 'Vape') cartVape += item.quantity || 0;
      else if (t === 'Batterie') cartBattery += item.quantity || 0;
      else if (isWeightType(t)) {
        const base = parseFloat((item.properties && item.properties._sku_base_amount) || 0) || 0;
        if (base > 0) {
          const m = getMultiplier(t);
          cartWeight += base * Math.max(1, Math.round((item.quantity || 1) / m));
        }
      }
    });
    const productCapHit = uniqueProducts.size >= MAX_PRODUCTS;

    document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
      // PDP buttons set their own cap state via the inline recompute() — skip them so we
      // don't fight that handler.
      if (btn.closest('[data-product-form-container]')) return;
      const form = btn.closest('form');
      if (!form) return;
      const adminType = btn.getAttribute('data-administration-type') || '';
      if (!adminType) return;

      const variantInput = form.querySelector('input[name="id"]');
      const variantId = variantInput ? parseInt(variantInput.value, 10) : NaN;
      const productInCart = !isNaN(variantId) && cartVariantIds.has(variantId);
      const base = parseFloat(btn.getAttribute('data-sku-base-amount') || '0') || 0;

      let blockReason = '';
      if (productCapHit && !productInCart) {
        blockReason = 'Warenkorb voll — max. ' + MAX_PRODUCTS + ' Produkte';
      } else if (isWeightType(adminType) && base > 0 && cartWeight + base > MAX_WEIGHT) {
        blockReason = 'Warenkorb voll — 100 g/ml Limit erreicht';
      } else {
        const typeLimit = getTypeLimit(adminType);
        if (typeLimit !== null) {
          const typeQty = adminType === 'Vape' ? cartVape : cartBattery;
          if (typeQty >= typeLimit) {
            blockReason = 'Warenkorb voll — max. ' + typeLimit + ' ' + adminType;
          }
        }
      }

      if (blockReason) {
        btn.setAttribute('data-cart-blocked', 'true');
        disableButton(btn, blockReason);
        if (btn.classList.contains('nuggmd-product-card__btn')) {
          btn.classList.add('nuggmd-product-card__btn--disabled');
        }
      } else if (btn.getAttribute('data-cart-blocked') === 'true') {
        btn.removeAttribute('data-cart-blocked');
        if (btn.getAttribute('data-blocked') !== 'true') {
          enableButton(btn);
          if (btn.classList.contains('nuggmd-product-card__btn')) {
            btn.classList.remove('nuggmd-product-card__btn--disabled');
          }
        }
      }
    });
  }

  function refreshCardButtons() {
    fetch('/cart.js')
      .then(safeJson)
      .then((cart) => { if (cart) syncCardButtons(cart); })
      .catch(() => {});
  }

  function handleAddToCart(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    const form = btn.closest('form');
    if (!form) return;

    // Only intercept cannabis products (those with administration_type set)
    const adminTypeInput = form.querySelector('input[name="properties[_administration_type]"]');
    const adminType = adminTypeInput ? adminTypeInput.value : (btn.getAttribute('data-administration-type') || '');
    if (!adminType) return;

    if (btn.disabled || btn.getAttribute('data-blocked') === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError('100 g/ml Limit erreicht — Produkt kann nicht hinzugefügt werden.');
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    const formData  = new FormData(form);
    const variantId = formData.get('id');
    let quantity    = parseInt(formData.get('quantity'), 10) || 1;
    if (!variantId) return;

    const multiplier = getMultiplier(adminType);

    // PDP forms submit quantity = N * multiplier (from the dropdown / static input),
    // but product-card ATC forms hardcode quantity=1. Without snapping, an Extrakt
    // (multiplier=30) added from a card would land at line_item.quantity=1, and the
    // cart's Liquid integer division (floor(1/30) * base = 0) would render it as
    // "0ml" — the bug QA hit. Always send Shopify a multiple of the multiplier.
    if (multiplier > 1) {
      quantity = Math.max(multiplier, Math.round(quantity / multiplier) * multiplier);
    }

    btn.disabled = true;
    btn.classList.add('loading');

    let _blocked = false;

    fetch('/cart.js')
      .then(safeJson)
      .then((cart) => {
        if (!cart) {
          showError('Warenkorb konnte nicht geladen werden. Bitte versuche es erneut.');
          return null;
        }

        const uniqueProducts = new Set();
        cart.items.forEach((item) => { uniqueProducts.add(item.product_id); });
        const isNewProduct = !cart.items.some((item) => item.variant_id == variantId);
        if (uniqueProducts.size >= MAX_PRODUCTS && isNewProduct) {
          showError('Maximal ' + MAX_PRODUCTS + ' verschiedene Produkte im Warenkorb erlaubt.');
          return null;
        }

        const typeLimit = getTypeLimit(adminType);
        if (typeLimit !== null) {
          let typeQty = 0;
          cart.items.forEach((item) => {
            if ((item.properties && item.properties._administration_type) === adminType) {
              typeQty += item.quantity || 0;
            }
          });
          if (typeQty + quantity > typeLimit) {
            const allowed = Math.max(0, typeLimit - typeQty);
            if (allowed <= 0) {
              showError('Maximal ' + typeLimit + ' ' + adminType + '-Artikel erlaubt.');
              return null;
            }
            showError('Menge wurde von ' + quantity + ' auf ' + allowed + ' ' + unitFor(adminType) + ' reduziert. Maximal ' + typeLimit + ' ' + adminType + '-Artikel erlaubt.');
            quantity = allowed;
          }
        }

        if (isWeightType(adminType)) {
          let cartWeight = 0;
          cart.items.forEach((item) => {
            const t = (item.properties && item.properties._administration_type) || '';
            if (!isWeightType(t)) return;
            const base = parseFloat((item.properties && item.properties._sku_base_amount) || 0);
            if (!base) return;
            const im = getMultiplier(t);
            cartWeight += base * Math.max(1, Math.round((item.quantity || 1) / im));
          });

          let productBase = 0;
          const baseEl = btn.getAttribute('data-sku-base-amount') ||
                         (form.querySelector('input[name="properties[_sku_base_amount]"]') || {}).value;
          if (baseEl) productBase = parseFloat(baseEl) || 0;

          if (productBase > 0) {
            // The form's quantity is the Shopify line-item quantity (opt_value = i * multiplier
            // in Liquid), not a pack count. Convert to packs for the weight calculation.
            const packs = Math.max(1, Math.round(quantity / multiplier));
            const potential = cartWeight + (packs * productBase);
            if (potential > MAX_WEIGHT) {
              const fits = Math.floor((MAX_WEIGHT - cartWeight) / productBase);
              if (fits <= 0) {
                showError('Warenkorb ist voll (100 g/ml). Keine weiteren Artikel möglich.');
                _blocked = true;
                btn.setAttribute('data-blocked', 'true');
                return null;
              }
              const unit = unitFor(adminType);
              showError('Menge von ' + (packs * productBase) + ' ' + unit + ' auf ' + (fits * productBase) + ' ' + unit + ' reduziert (100 g/ml Limit).');
              quantity = fits * multiplier;
            }
          }
        }

        return { quantity };
      })
      .then((result) => {
        if (!result) return;

        // result.quantity is already the Shopify line-item quantity — do not re-multiply.
        const cartPayload = { id: variantId, quantity: result.quantity, properties: {} };

        // Nest properties[x] form fields under properties: { x } for Shopify JSON API
        for (const pair of formData.entries()) {
          if (pair[0] === 'id' || pair[0] === 'quantity' || pair[0] === 'form_type' || pair[0] === 'utf8') continue;
          const propMatch = pair[0].match(/^properties\[(.+)\]$/);
          if (propMatch) {
            cartPayload.properties[propMatch[1]] = pair[1];
          }
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(cartPayload)
        })
          .then(safeJson)
          .then((data) => {
            if (!data) {
              showError('Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
              return;
            }
            if (data.status) {
              showError(data.description || data.message || 'Fehler beim Hinzufügen zum Warenkorb.');
            } else {
              document.dispatchEvent(new CustomEvent('cart:updated'));
              if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
              if (window.cart && typeof window.cart.openCartDrawer === 'function') window.cart.openCartDrawer();
            }
          });
      })
      .catch(() => {
        showError('Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      })
      .finally(() => {
        if (!_blocked) btn.disabled = false;
        btn.classList.remove('loading');
        debounce('afterAdd', updateProgressBar, 300);
      });
  }

  function guardFormSubmit(e) {
    const form = e.target;
    const btn  = form.querySelector('[data-add-to-cart]');
    if (btn && (btn.getAttribute('data-blocked') === 'true' || btn.getAttribute('data-cart-blocked') === 'true')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  function handleCartDropdownChange(select) {
    const lineKey = select.getAttribute('data-line-key');
    const quantity = parseInt(select.value, 10);
    if (!lineKey || isNaN(quantity)) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(safeJson)
      .then((data) => {
        if (!data) {
          showError('Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
          return;
        }
        dismissDrawerError();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
        debounce('afterCartChange', updateProgressBar, 300);
      })
      .catch(() => {
        showError('Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
      });
  }

  let _initialized = false;

  function init() {
    if (_initialized) return;
    _initialized = true;

    document.addEventListener('change', (e) => {
      const select = e.target.closest('[data-cart-qty-select]');
      if (select) handleCartDropdownChange(select);
    });

    document.addEventListener('click', handleAddToCart, true);
    document.addEventListener('submit', guardFormSubmit, true);

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-toggle]')) {
        dismissDrawerError();
        debounce('cartToggle', updateProgressBar, 500);
        debounce('cartToggleNorm', normalizeQtyOptions, 600);
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-item-remove]') || e.target.closest('.cart-product__remove')) {
        dismissDrawerError();
        setTimeout(updateProgressBar, 500);
        setTimeout(updateProgressBar, 1500);
      }
    });

    ['cart:updated', 'cart:update', 'cart:change', 'cart:build',
     'cart:requestComplete', 'ajaxCart:updated',
     'ajaxProduct:added', 'ajaxProduct:removed'
    ].forEach((name) => {
      document.addEventListener(name, () => {
        debounce('cartEvent', updateProgressBar, 200);
        debounce('cartEventNorm', normalizeQtyOptions, 250);
        debounce('cartEventBtns', refreshCardButtons, 250);
      });
    });

    // Snap cart quantity fields to multiplier increments (cart items only, not PDP)
    document.addEventListener('change', (e) => {
      if (!e.target.matches('[data-quantity-field]')) return;
      const row = e.target.closest('[data-item]');
      if (!row) return;
      const m = Math.max(1, parseInt(row.getAttribute('data-multiplier') || '5', 10));
      let raw = parseInt(e.target.value, 10) || m;
      e.target.value = Math.max(m, Math.round(raw / m) * m);
      debounce('fieldChange', updateProgressBar, 200);
    });

    // Fetch interceptor — enforces limits on /cart/add.js at the network level
    const _origFetch = window.fetch;
    window.fetch = function (url, opts) {
      const isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      const isCartMod = typeof url === 'string' &&
        (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/update') !== -1 ||
         url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/clear') !== -1);

      if (isCartAdd && opts && opts.body) {
        let adminType = '';
        let productBase = 0;
        let quantity = 1;
        let jsonPayload = null;

        if (typeof opts.body === 'string') {
          try {
            jsonPayload = JSON.parse(opts.body);
            const props = jsonPayload.properties || {};
            adminType   = props._administration_type || jsonPayload['properties[_administration_type]'] || '';
            productBase = parseFloat(props._sku_base_amount || jsonPayload['properties[_sku_base_amount]'] || '0');
            quantity    = jsonPayload.quantity || 1;
          } catch (e) { jsonPayload = null; }
        } else if (opts.body instanceof FormData) {
          adminType   = opts.body.get('properties[_administration_type]') || '';
          productBase = parseFloat(opts.body.get('properties[_sku_base_amount]') || '0');
          quantity    = parseInt(opts.body.get('quantity'), 10) || 1;
        }

        if (!productBase || !adminType) {
          const atcBtn = document.querySelector('[data-add-to-cart][data-sku-base-amount]');
          if (atcBtn) {
            if (!productBase) productBase = parseFloat(atcBtn.getAttribute('data-sku-base-amount') || '0');
            if (!adminType) adminType = atcBtn.getAttribute('data-administration-type') || '';
          }
        }

        const mult = getMultiplier(adminType);
        const fetchContext = this;

        if (productBase > 0 || adminType) {
          // Fetch cart section HTML to get accurate weight (has data attrs from Liquid metafields)
          return _origFetch.call(fetchContext, '/cart?section_id=api-cart-items')
            .then((r) => r.ok ? r.text() : null)
            .catch(() => null)
            .then((html) => {
              if (!html) return _origFetch.apply(fetchContext, [url, opts]);

              const doc = new DOMParser().parseFromString(html, 'text/html');
              let cartWeight = 0;
              const typeTotals = { Vape: 0, Batterie: 0 };
              doc.querySelectorAll('[data-item][data-sku-base-amount]').forEach((item) => {
                const t = item.getAttribute('data-administration-type') || '';
                if (isWeightType(t)) {
                  const base = parseFloat(item.getAttribute('data-sku-base-amount') || '0');
                  if (base > 0) {
                    const im = getMultiplier(t);
                    const input = item.querySelector('[data-quantity-field]');
                    if (!input) return;
                    const raw = parseInt(input.value, 10);
                    if (isNaN(raw) || raw < 1) return;
                    cartWeight += base * Math.max(1, Math.round(raw / im));
                  }
                }
                if (t in typeTotals) {
                  const input = item.querySelector('[data-quantity-field]');
                  typeTotals[t] += input ? (parseInt(input.value, 10) || 0) : 0;
                }
              });

              const effectiveQty = Math.max(1, Math.round(quantity / mult));
              const fakeBlock = (msg) => Promise.resolve(new Response(
                JSON.stringify({ status: 422, message: msg, description: msg }),
                { status: 422, headers: { 'Content-Type': 'application/json' } }
              ));

              if (isWeightType(adminType) && productBase > 0) {
                const wouldBe = cartWeight + (effectiveQty * productBase);
                if (wouldBe > MAX_WEIGHT) {
                  const fits = Math.floor((MAX_WEIGHT - cartWeight) / productBase);
                  if (fits <= 0) {
                    showError('Warenkorb ist voll (100 g/ml). Keine weiteren Artikel möglich.');
                    debounce('fetchBlock', updateProgressBar, 300);
                    return fakeBlock('Warenkorb-Limit erreicht');
                  }
                  const newQty = fits * mult;
                  if (jsonPayload) {
                    jsonPayload.quantity = newQty;
                    opts = Object.assign({}, opts, { body: JSON.stringify(jsonPayload) });
                  } else if (opts.body instanceof FormData) {
                    opts.body.set('quantity', String(newQty));
                  }
                  showError('Menge auf ' + (fits * productBase) + ' ' + unitFor(adminType) + ' reduziert (100 g/ml Limit).');
                }
              }

              const typeLimit = getTypeLimit(adminType);
              if (typeLimit !== null) {
                const currentTypeQty = typeTotals[adminType] || 0;
                const addingQty = jsonPayload ? (jsonPayload.quantity || quantity) : quantity;
                if ((currentTypeQty + addingQty) > typeLimit) {
                  const allowed = Math.max(0, typeLimit - currentTypeQty);
                  if (allowed <= 0) {
                    showError('Maximal ' + typeLimit + ' ' + adminType + '-Artikel erlaubt.');
                    return fakeBlock('Typ-Limit erreicht');
                  }
                  if (jsonPayload) {
                    jsonPayload.quantity = allowed;
                    opts = Object.assign({}, opts, { body: JSON.stringify(jsonPayload) });
                  } else if (opts.body instanceof FormData) {
                    opts.body.set('quantity', String(allowed));
                  }
                  showError('Menge reduziert. Maximal ' + typeLimit + ' ' + adminType + '-Artikel erlaubt.');
                }
              }

              const result = _origFetch.apply(fetchContext, [url, opts]);
              result.then(() => { debounce('fetchCart', updateProgressBar, 300); }).catch(() => {});
              return result;
            });
        }
      }

      const result = _origFetch.apply(this, [url, opts]);
      if (isCartMod) {
        result.then(() => { debounce('fetchCart', updateProgressBar, 300); }).catch(() => {});
      }
      return result;
    };

    const cartContainer = document.querySelector('.cart, [data-cart], .cart-form, .cart-drawer, [data-cart-drawer]');
    if (cartContainer) {
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0)) {
            const targetEl = m.target.nodeType === 1 ? m.target : m.target.parentElement;
            if (targetEl && targetEl.closest('[data-cart-progress-bar]')) continue;
            debounce('domChange', updateProgressBar, 300);
            break;
          }
        }
      }).observe(cartContainer, { childList: true, subtree: true });
    }

    if (window.CartJS) {
      CartJS.subscribe('cart.requestComplete', () => {
        debounce('cartJS', updateProgressBar, 200);
      });
    }

    // bfcache restores keep stale cart counters from the previous visit
    // (e.g., user lands on home with counter=0, opens PDP, adds an item, hits back).
    // Re-sync the header counter from the live cart whenever the page is restored.
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      fetch('/cart.js')
        .then(safeJson)
        .then((cart) => {
          if (!cart) return;
          const count = cart.item_count;
          document.querySelectorAll('[data-cart-items-count]').forEach((el) => {
            el.innerText = count < 10 ? String(count) : '9+';
          });
          document.querySelectorAll('[data-cart-items-size]').forEach((el) => {
            el.innerText = String(cart.items.length);
          });
          document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
            el.classList.toggle('cartToggle--empty', count === 0);
          });
        })
        .catch(() => {});
      debounce('pageshow', updateProgressBar, 100);
    });

    debounce('init', updateProgressBar, 300);
    debounce('initNorm', normalizeQtyOptions, 300);
    debounce('initBtns', refreshCardButtons, 300);
  }

  return {
    MAX_WEIGHT, MAX_PRODUCTS, TYPE_LIMITS, MULTIPLIERS,
    getMultiplier, isWeightType, unitFor,
    getCartWeightFromDOM, getCartWeightFromAPI, getTypeQuantityFromDOM, getTypeLimit,
    disableButton, enableButton,
    updateProgressBar, showError, dismissNotification,
    normalizeQtyOptions, syncCardButtons, refreshCardButtons,
    init
  };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { CannabisLimits.init(); });
} else {
  CannabisLimits.init();
}
